import { useTheme } from "@emotion/react";
import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import React from "react";

const SearchButtonArea = (props) => {
  const { handleSearch, handleClear, searchDisabled, clearDisabled } = props;
  const theme = useTheme();
  const isPc = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <>
      <Grid item xs={isPc ? 2 : 4} sx={{ marginTop: isPc ? "36px" : "0px" }}>
        <Button
          variant="outlined"
          sx={{
            fontSize: "8px",
            fontWeight: "bold",
            color: "#15B855",
            borderColor: "#15B855",
            padding: "0px 16px",
            height: "40px",
            margin: "auto",
          }}
          onClick={handleSearch}
          disabled={searchDisabled}
        >
          検索
        </Button>
      </Grid>
      <Grid item xs={isPc ? 2 : 4} sx={{ marginTop: isPc ? "36px" : "0px" }}>
        <Button
          variant="outlined"
          sx={{
            fontSize: "8px",
            fontWeight: "bold",
            color: "#15B855",
            borderColor: "#15B855",
            padding: "0px 16px",
            height: "40px",
            margin: "auto",
          }}
          onClick={handleClear}
          disabled={clearDisabled}
        >
          クリア
        </Button>
      </Grid>
    </>
  );
};

export default SearchButtonArea;
